<script setup lang="ts">
const props = defineProps<{
    text: string,
    btnStyle: string,
    svgBgStyle: string,
    svgStyle: string
}>()
</script>

<template>
    <button
        class="w-full flex justify-center gap-2 items-center !h-10 rounded-[24px] px-4 !text-xs lg:!text-sm !font-medium"
        :class="props.btnStyle"
    >
        {{ props.text }}
        <div class="w-4 lg:w-5 h-4 lg:h-5 rounded-full flex justify-center items-center" :class="props.svgBgStyle">
            <IconArrowDown class="w-2 lg:w-3 aspect-square rotate-90" :class="props.svgStyle" />
        </div>
    </button>
</template>
